import Icon from '../components/Icon.vue'

Icon.register({
  hourglass: {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M360 64c0 91-51 167.7-120.8 192 69.8 24.3 120.8 101 120.8 192 13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24h-336c-13.3 0-24-10.7-24-24v-16c0-13.3 10.7-24 24-24 0-91 51-167.7 120.8-192-69.8-24.3-120.8-101-120.8-192-13.3 0-24-10.7-24-24v-16c0-13.3 10.7-24 24-24h336c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/hourglass.js
// module id = 1471
// module chunks = 0